export default "__VITE_ASSET__y_JgHG39__"